import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import config from '../config'

import StyledLink from './StyledLink'

const NavElement = styled.h2`
  display: inline;
  margin-right: 0.25em;
  margin-bottom: 0;
`

const NavStyledLink = StyledLink.extend`
  color: ${props => props.color};
`

// Define colors for nav links
const linkColors = {
  active: config.navLinkColorActive,
  inactive: config.navLinkColor
};

class NavLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'inactive'
    };
  }

  render() {
    // trick needed to avoid error: WebpackError: window is not defined
    const windowGlobal = typeof window !== 'undefined' && window
    if (windowGlobal && windowGlobal.location.pathname === this.props.to) {
      this.state.status = 'active'
    } else {
      this.state.status = 'inactive'
    }

    return (
      <NavElement><NavStyledLink color={linkColors[this.state.status]} to={this.props.to}>{this.props.children}</NavStyledLink></NavElement>
    );
  }
}

export default NavLink



// WEBPACK FOOTER //
// ./src/components/NavLink.js